import React from "react";

/**
 * A consistent global headline style used across the site.
 * Matches the styling for the “Every month spent ramping a team is a month your value creation plan sits idle.” title.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Content to render inside the headline.
 * @param {string} [props.className] - Additional CSS classes.
 * @param {string} [props.as] - HTML element to render (default: "p").
 */
const GlobalHeadline = ({ children, className = "", as: Component = "p", ...props }) => (
  <Component className={["global-headline", className].filter(Boolean).join(" ")} {...props}>
    {children}
  </Component>
);

export default GlobalHeadline;
